import { useCallback } from "react";
import { graphql, useMutation } from "react-relay";

import type {
  hooksReactionMutation,
  hooksReactionMutation$data,
} from "scmp-app/queries/__generated__/hooksReactionMutation.graphql";

import type { ReactionPayload } from "./types";

export const useReaction = () => {
  const [commitMutation, isLoading] = useMutation<hooksReactionMutation>(graphql`
    mutation hooksReactionMutation(
      $targetEntityId: String!
      $action: UpvoteAction!
      $type: UpvoteType!
    ) {
      upvote(targetEntityId: $targetEntityId, action: $action, type: $type) {
        id
        upvoted
        ...contentReactionDisplayUpvote
      }
    }
  `);

  const handleReactionAction = useCallback(
    (payload: ReactionPayload, callback?: (data: hooksReactionMutation$data) => void) => {
      commitMutation({
        onCompleted: response => {
          callback?.(response);
        },
        variables: {
          action: payload.action,
          targetEntityId: payload.entityId,
          type: "Article",
        },
      });
    },
    [commitMutation],
  );

  return { handleReactionAction, isLoading };
};
